import React, { useEffect, useState } from "react";
import "./App.css";
import Home from "./pages/Home";
import Products from "./pages/Products";
import Contact from "./pages/Contact";
import Navbar from "./components/Navbar";
import { motion } from "framer-motion";
import Logo from "./assets/images/eg-logo.svg";
import { Route, Routes } from "react-router-dom";

function App() {
 // Splash Screen //
  const [isLoading, setIsLoading] = useState(true);

    // Typewriter Component
function TypewriterText({ text = "", speed = 100 }) {
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    setDisplayedText("");
    const safeText = String(text ?? "");
    let i = 0;
    const interval = setInterval(() => {
      if (i < safeText.length) {
        const char = safeText[i];
        if (char !== undefined) {
          setDisplayedText(prev => prev + char);
        }
        i++;
      } else {
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed]);

  return (
    <motion.p
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      style={{
        fontFamily: "monospace",
        fontSize: ".75rem",
        whiteSpace: "pre-wrap",
        textAlign: "left",
      }}
    >
      {displayedText}
    </motion.p>
  );
}
  // Loading screen timer
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 4000);
    return () => clearTimeout(timer);
  }, []);
  if (isLoading) {
    return (
      <motion.div
        className="loading-screen"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1.5 }}
        style={{
          backgroundColor: "black",
          color: "white",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          display: "flex",
          flexDirection: "row"
        }}
      >
        <img
          src={Logo}
          alt="Site Logo"
          style={{ width: "150px", marginBottom: "1rem" }}
        />
        <TypewriterText
          text={"From the Garden came the ingredients.\nFrom the ingredients came Transcendence\nAnd every one outside of the Garden grew Envious"}
          speed={20}
        />
      </motion.div>
    );
  }

  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

export default App;
